import { createAsyncThunk } from '@reduxjs/toolkit';
import ContactService from '../services/ContactService';

const NAME = 'CONTACT';

const sendRequest = createAsyncThunk(
    `${NAME}/sendRequest`,
    ContactService.sendRequest,
);

const ContactActions = {
    sendRequest,
};

export default ContactActions;
